const BYTES_PER_KB = 1000;

export function formatFileSize(size?: number | null): string | null {
  if (size == null) {
    return null;
  }

  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (size < BYTES_PER_KB) {
    return `${size} ${units[0]}`;
  }

  const unitIdx = Math.floor(Math.log(size) / Math.log(BYTES_PER_KB));
  const formatedSize = `${(size / Math.pow(BYTES_PER_KB, unitIdx)).toFixed(2)}`;

  return `${formatedSize} ${units[unitIdx]}`;
}
